module.exports = __webpack_public_path__ + "static/media/TRAD.2ae08c95.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/TRAD.jpg
// module id = 1782
// module chunks = 1